import React, { PropTypes as T } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector, propTypes } from 'redux-form/immutable';

import { DELIVERABLE_SUBMIT, DELIVERABLE, BLOG, VIDEO } from '../../utils/static-configuration';
import SelectInput from '../../components/form-input-select';
import TextInput from '../../components/form-input-text';
import RadioInput from '../../components/form-input-radio';
import { submitDeliverable, setInitialSubmitType, updateAddDeliverableForm } from './actions';
import Uploader from '../../components/uploader';
import { clearModal } from '../../actions/modal';

class DeliverableSubmit extends React.Component {
  static contextTypes = {
    router: T.object,
  };

  static propTypes = {
    ...propTypes,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      uploaderState: 1,
      documentData: {},
    };
  }

  uploadDataCallback = documentData => {
    this.setState({ documentData });
  };

  clearModal() {
    this.setState({ uploaderState: 1, documentData: {} });
    this.props.reset();
  }

  submitExistingDeliverable(formData) {
    const submitType = formData.get('submitType');
    const deliverableId = formData.get('selectedDeliverable');
    const title = this.props.deliverables.getIn([deliverableId, 'title']);
    const version = this.props.deliverables.getIn([deliverableId, 'version']);

    let filePath, message, size, name = null;
    if (submitType === 'url') {
      message = formData.get('submitMessage');
      filePath = formData.get('deliverableUrl');
      if (filePath.indexOf('http://') === -1 && filePath.indexOf('https://') === -1) filePath = 'http://' + filePath;
    }
    if (submitType === 'upload') {
      message = formData.get('submitDocumentMessage');
      name = this.state.documentData.name;
      filePath = this.state.documentData.filePath;
      size = this.state.documentData.size;
    }
    if (submitType === 'text') {
      filePath = formData.get('copyText');
    }

    const deliverableData = {
      id: deliverableId,
      message,
      filePath,
      title,
      name,
      fileType: submitType,
      size,
      version,
    };

    this.props.onSubmitDeliverable(deliverableData, submitType, this.resetForm);
  }

  onOutsideClick(event) {
    let isClickInside = this.refs.modal_content.contains(event.target);
    if (!isClickInside) this.props.onClearModal();
  }

  updateUploaderState = newUploaderState => {
    this.setState({ uploaderState: newUploaderState });
  };

  resetForm = () => {
    this.setState({ uploaderState: 1 });
    this.props.reset();
  };

  componentWillUnmount() {
    this.resetForm();
  }

  componentDidMount() {
    const selectedDeliverable = this.props.selectedDeliverable;
    if (selectedDeliverable) this.updateSubmitDeliverableOptions(selectedDeliverable);
  }

  changeSubmitTypeCallback = submitType => this.props.change('submitType', submitType);

  updateSubmitDeliverableOptions = deliverableId => {
    this.props.onUpdateAddDeliverableForm(deliverableId, this.changeSubmitTypeCallback);
  };

  render() {
    const { uploaderState, documentData } = this.state;
    const {
      handleSubmit,
      deliverables,
      showModal,
      modalLoading,
      submitType,
      isUploadActive,
      isUrlActive,
      isTextActive,
      assetType,
      selectedDeliverable,
    } = this.props;

    const deliverableOptions = [];
    deliverables.forEach(deliverable => {
      if (!deliverable.get('live')) {
        const id = deliverable.get('id');
        const title = deliverable.get('title');
        const assetType = deliverable.get('assetType');
        const adjustedAssetType = assetType ? assetType.split(',')[0].toLowerCase() : null;
        const label = `${title} (${adjustedAssetType})`;
        const documentsList = deliverable.get('documents');
        if (documentsList && documentsList.first()) {
          const deliverableApproved = documentsList.find(document => document.get('approved') === true);
          if (!deliverableApproved) deliverableOptions.push({ value: id, label });
        } else if (!deliverable.getIn(['document', 'approved'])) {
          deliverableOptions.push({ value: id, label });
        }
      }
    });

    return (
      <div className={showModal === DELIVERABLE_SUBMIT ? 'custom-modal visible' : 'custom-modal'} onClick={this.onOutsideClick.bind(this)}>
        <form onSubmit={handleSubmit(this.submitExistingDeliverable.bind(this))}>
          <div className="modal-content" ref="modal_content">
            <div className="top">
              <h3>Add a deliverable</h3>
            </div>
            <div className="modal-close">
              <img src="/icons/close.svg" alt="close" onClick={() => this.props.onClearModal()} />
            </div>
            <div className="center">
              <table>
                <tbody>
                  <tr>
                    <td width="150px">
                      <h4>Select deliverable</h4>
                    </td>
                    <td>
                      <Field
                        name="selectedDeliverable"
                        component={props => (
                          <SelectInput
                            name="selectedDeliverable"
                            label=""
                            className="stacked"
                            onChangeCallback={deliverableId => this.updateSubmitDeliverableOptions(deliverableId)}
                            {...props}
                            options={deliverableOptions}
                          />
                        )}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td width="180px">
                      <h4>Add deliverable by</h4>
                    </td>
                    <td>
                      <div className="spacer small" />
                      <div className="radio-row">
                        <Field
                          id="url"
                          type="radio"
                          component={RadioInput}
                          name="submitType"
                          value="url"
                          label="URL"
                          disabled={isUrlActive ? false : true}
                        />
                        <Field
                          id="upload"
                          type="radio"
                          component={RadioInput}
                          name="submitType"
                          value="upload"
                          label="upload"
                          disabled={isUploadActive ? false : true}
                        />
                        <Field
                          id="text"
                          type="radio"
                          component={RadioInput}
                          name="submitType"
                          value="text"
                          label="write"
                          disabled={isTextActive ? false : true}
                        />
                      </div>
                    </td>
                  </tr>
                  { submitType === 'url' &&
                    <tr>
                      <td colSpan={2}>
                        <Field
                          name="deliverableUrl"
                          type="text"
                          label=""
                          component={TextInput}
                          placeholder={assetType === VIDEO ? 'Youtube URL or other video link' : 'URL link to your draft post'}
                        />
                      </td>
                    </tr>
                  }
                  { submitType === 'url' && assetType !== BLOG &&
                    <tr>
                      <td colSpan={2}>
                        <p>Include the copy for your post if applicable</p>
                      </td>
                    </tr>
                  }
                  { submitType === 'url' && assetType !== BLOG &&
                    <tr>
                      <td colSpan={2}>
                        <Field
                          name="submitMessage"
                          component="textarea"
                          placeholder="write your copy here"
                        />
                      </td>
                    </tr>
                  }
                  { submitType === 'upload' &&
                    <tr>
                      <td colSpan={2}>
                        <Uploader
                          uploaderState={uploaderState}
                          updateUploaderState={this.updateUploaderState}
                          docType={DELIVERABLE}
                          uploadDataCallback={this.uploadDataCallback}
                        />
                      </td>
                    </tr>
                  }
                  { submitType === 'upload' && uploaderState === 6 && assetType !== BLOG &&
                    <tr>
                      <td colSpan={2}>
                        <p>Include the copy for your post if applicable</p>
                      </td>
                    </tr>
                  }
                  { submitType === 'upload' && uploaderState === 6 && assetType !== BLOG &&
                    <tr>
                      <td colSpan={2}>
                        <Field
                          name="submitDocumentMessage"
                          component="textarea"
                          placeholder="write your copy here"
                        />
                      </td>
                    </tr>
                  }
                  { submitType === 'text' &&
                    <tr>
                      <td colSpan="2">
                        <Field
                          name="copyText"
                          component="textarea"
                          placeholder="write your copy here"
                        />
                      </td>
                    </tr>
                  }
                  { ((submitType === 'upload' && documentData.filePath) || submitType === 'url' || submitType === 'text') &&
                    <tr>
                      <td colSpan="2">
                        <div className="spacer" />
                        <button className="medium rose stretch" type="submit">
                          { modalLoading
                            ? <ul className="dots">
                                <li id="dot1" />
                                <li />
                                <li id="dot2" />
                                <li />
                                <li id="dot3" />
                              </ul>
                            : <span>Add deliverable</span>
                          }
                        </button>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

DeliverableSubmit.propTypes = {
  routeParams: React.PropTypes.object,
};

function validate(values) {
  const errors = {};

  // No validation done on deliverables for now
  const selectedDeliverable = values.get('selectedDeliverable');
  const submitType = values.get('submitType');
  const deliverableUrl = values.get('deliverableUrl');
  const copyText = values.get('copyText');

  if (!selectedDeliverable) {
    errors.selectedDeliverable = 'Please select a deliverable';
  }
  if (submitType === 'url') {
    if (!deliverableUrl) errors.deliverableUrl = 'Please include a URL to the deliverable';
  }
  if (submitType === 'text') {
    if (!copyText) errors.copyText = 'Please add the copy text for the deliverable';
  }

  return errors;
}

// Used to map the form state to props to allow for custom form render logic
const selector = formValueSelector('DeliverableSubmitForm');

const mapStateToProps = state => {
  return {
    deliverables: state.discussion.get('deliverables'),
    discussionId: state.discussion.get('discussionId'),
    showModal: state.modal.get('showModal'),
    modalLoading: state.modal.get('loading'),
    modalError: state.modal.get('error'),
    submitType: selector(state, 'submitType'),
    isUploadActive: state.deliverableSubmit.get('isUploadActive'),
    isUrlActive: state.deliverableSubmit.get('isUrlActive'),
    isTextActive: state.deliverableSubmit.get('isTextActive'),
    assetType: state.deliverableSubmit.get('assetType'),
    selectedDeliverable: state.deliverableSubmit.get('selectedDeliverable'),
    initialValues: {
      submitType: state.deliverableSubmit.get('initialSubmitType'),
      selectedDeliverable: state.deliverableSubmit.get('selectedDeliverable'),
    },
  };
};

export function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    onSubmitDeliverable: (deliverableData, submitType, submitDeliverableCallback) => dispatch(submitDeliverable(deliverableData, submitType, submitDeliverableCallback)),
    onSetInitialSubmitType: data => dispatch(setInitialSubmitType(data)),
    onUpdateAddDeliverableForm: (deliverableId, callback) => dispatch(updateAddDeliverableForm(deliverableId, callback)),
    onClearModal: () => dispatch(clearModal()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'DeliverableSubmitForm',
    validate,
  })(DeliverableSubmit),
);



/** WEBPACK FOOTER **
 ** ./src/containers/deliverable-submit-modal/index.js
 **/